import { createSharedPathnamesNavigation } from 'next-intl/navigation';
import { acceptedLocales, localePrefix } from './config';

export const locales = [...acceptedLocales] as const;

export const { Link, redirect, usePathname, useRouter } =
  createSharedPathnamesNavigation({ locales, localePrefix });
